export default __webpack_public_path__ + "static/media/detail_mobile_2_1.235ea430.png";